module.exports = __webpack_public_path__ + "static/TiemposText-Regular-26f2f5257c3ec2175d8221516c2a8e2f.woff";